import { Button } from 'components/Button';
import { useState } from 'react';
import styled from 'styled-components';
import BacktoTop from 'assets/backtotop/backtotop.svg';

export const Content = styled.div`
   overflowY: scroll;
   height: 2500px;
`;

export const ScrollingButton = styled(Button)`
    position: fixed; 
    right: 0;
    bottom: 0;
    z-index: 1;
    cursor: pointer;
    background: ${(props) => props.theme.colors.imgBackgroundColor};
    background-image: url(${BacktoTop});
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 0px;
`

export const ScrollButton = () => {

    const [visible, setVisible] = useState(false)

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 300) {
            setVisible(true)
        }
        else if (scrolled <= 300) {
            setVisible(false)
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    window.addEventListener('scroll', toggleVisible);

    return (
        <>
            <ScrollingButton onClick={scrollToTop}
                style={{ display: visible ? 'inline' : 'none' }}>
            </ScrollingButton>
        </>
    );
}

export default ScrollButton;